import React, { useEffect } from "react";
import { connect } from "react-redux";
import { TicketAction } from "../../../../actions";
import { Box, Container } from "./style";
import Button from "../../../../components/button";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Uploader from "../../../../hocs/transactionForm/components/uploader";
import FormPicker from "../../../../selectors/formPicker";
import uuidv4 from "uuid/v4";
import Input from "../../../../components/input";
import { StyledIcon } from "../../../../assets/globalStyles/styledIcon";
import {
  ticketTextLength,
  ticketTitleLength
} from "../../../../constants/maxLenghtAtrribute";
import { PROJECT_USER_ID } from "../../../../constants/storageKeys";

const TextArea = props => {
  return (
    <React.Fragment>
      <textarea
        placeholder={props.placeholder}
        onChange={e => {
          props.input.onChange(e.target.value);
        }}
        value={props.input.value}
        maxLength={ticketTextLength}
      />
      <span className="error">{props.meta.error}</span>
    </React.Fragment>
  );
};

const Form = props => {
  const {
    modalData,
    modalStatus,
    processing,
    formData,
    handleSubmit,
    initialize,
    change,
    store,
    update,
    closeModal
  } = props;

  useEffect(() => {
    if (modalStatus) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalStatus]);

  useEffect(() => {
    initialize({
      title: modalData && modalData.title,
      files: []
    });
  }, [modalData]);

  const isUpdate = () => {
    return modalData && modalData.id;
  };
  const submit = values => {
    let errors = {};
    const isUpdateMode = isUpdate();
    if (!isUpdateMode && !values.title) {
      errors.title = "وارد کردن عنوان پیام الزامی است";
    }
    if (!values.text) {
      errors.text = "وارد کردن توضیحات الزامی است ";
    }
    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    } else {
      const projectUserId = parseInt(localStorage.getItem(PROJECT_USER_ID));

      if (isUpdateMode) {
        delete values.title;
        update(modalData.id, {
          ...values,
          project_user_id: projectUserId,

          uuid: uuidv4()
        });
      } else {
        store({
          ...values,
          project_user_id: projectUserId,
          uuid: uuidv4()
        });
      }
    }
  };
  const titlesView = () => {
    return (
      <div className="titles">
        <Field
          name="title"
          component={Input}
          placeholder="عنوان پیام"
          maxLength={ticketTitleLength}
        />
      </div>
    );
  };

  if (!modalStatus) {
    return "";
  } else {
    return (
      <Container onClick={closeModal}>
        <Box
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className="header">
            <div className="title">
              <i className="icon mapsa-feedback" />
              {isUpdate() ? "پاسخ به پیام" : "پیام جدید"}
            </div>
            <StyledIcon fontSize={12} size={24}>
              <i className="icon mapsa-close" onClick={closeModal} />
            </StyledIcon>
          </div>
          <form onSubmit={handleSubmit(submit)}>
            {!isUpdate() && titlesView()}
            <Field
              component={TextArea}
              name="text"
              placeholder="افزودن توضیحات"
            />
            {modalData && modalData.hint && (
              <div className="hint">{modalData.hint}</div>
            )}
            <Uploader
              accept={["image/png", "image/jpeg", "image/jpg"]}
              limit="3"
              input={{
                value: formData && formData.values ? formData.values.files : []
              }}
              isFixed
              change={change}
            />
            <div className="file-notice">
              برای انتقال بهتر اطلاعات می‌توانید تصاویر مورد نظر خود را
              بار‌گذاری کنید.
            </div>
            <div className="buttons">
              <Button btn="primary" loading={processing}>
                ارسال پیام
              </Button>
            </div>
          </form>
        </Box>
      </Container>
    );
  }
};

const mapStateToProps = store => {
  return {
    modalData: store.Ticket.modalData,
    modalStatus: store.Ticket.modalStatus,
    processing: store.Ticket.processing,
    formData: FormPicker(store, "ticket")
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(TicketAction.closeModal());
    },
    store: data => {
      dispatch(TicketAction.storeRequest(data));
    },
    update: (id, data) => {
      dispatch(TicketAction.updateRequest(id, data));
    }
  };
};

const Index = reduxForm({
  form: "ticket"
})(Form);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
